import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const authReq = req.clone({ withCredentials: true });
  return next(authReq).pipe(
    catchError(err => {
      // Redirect to login only on session expiry (user WAS authenticated).
      // Initial auth check (/api/auth/me) and unauthenticated startup are
      // handled by authGuard after app initialization completes.
      if (err instanceof HttpErrorResponse && err.status === 401
          && auth.isAuthenticated()
          && !req.url.endsWith('/api/auth/me')) {
        auth.currentUser.set(null);
        router.navigate(['/login']);
      }
      return throwError(() => err);
    })
  );
};
